import brandWhite from "assets/logos/logo.png";
import brandDark from "assets/logos/logo-dark.png";

export default {
  brandWhite,
  brandDark,
};
